// @flow

import { useMemo } from 'react';
import type { Feature } from '@tectonics/prs/feature';
import { usePaymentSpec } from './context-use';
import { getAllFeatures } from './get-all-features';

export function useAllFeatures(): ImmutableArray<Feature> {
  const spec = usePaymentSpec();
  return useMemo(() => getAllFeatures(spec), [spec]);
}
